import React, { forwardRef, ReactNode, useEffect, useState, useCallback } from 'react';
// import classnames from 'classnames';
import { ByzzerChangeEventHandler, ByzzerSearch, WithValue } from '@byzzer/ui-components';
import {useTenantApi} from '@/hooks/useTenantApi';
import { caseInsensitiveSort } from '@/utils/Sort';
import classnames from 'classnames';
import { useApp } from '@/contexts/UserContext';

const baseClassName = 'omni-brand-search';

export type OmniBrandSearchProps = {
    value?: string[];
    className?: string;
    name?: string;
    label?: ReactNode;
    onChange?: ByzzerChangeEventHandler<string[]>;
    placeholder?: string;
    maxBrands?: number; //decides how many brands we can add in dropdown
    disabled?: boolean;
    omniCategories?: string[];
} & OnlyRenderableIf;

export const OmniBrandSearch = forwardRef<WithValue<string[]>, OmniBrandSearchProps>(
    (
        {
            className,
            label,
            name,
            onChange,
            value,
            placeholder = 'Search For Omni Brands',
            maxBrands,
            disabled,
            onlyRenderIf = true,
            omniCategories,
            ...props
        },
        ref
    ) => {
        if (onlyRenderIf === false) return <></>;
        const { findOmniBrandsInCategories } = useTenantApi();
        const { omniCategories: omniCategoriesFromSubscription}  = useApp();
        const omniCategoriesList = omniCategories ?? omniCategoriesFromSubscription;
        const [internalValue, setInternalValue] = useState<string[]>();

        useEffect(() => {
            setInternalValue(value);
        }, [value])

        const findBrandsForOmni = useCallback(async (searchText: string): Promise<{brands: string[]}> => {
            const { brands } = await findOmniBrandsInCategories({
                categories: omniCategoriesList,
                searchTerm: searchText
            }); // todo - recommend in Alby, use context categories vs select categories flag.
            return brands;
        }, [omniCategoriesList]);

        const handleChange = (e: any) => {
            const newBrandPayload = {
                value: e.value.map((brand) => brand.value),
                name,
                data: e.data
            }
            if (onChange) {
                onChange?.(newBrandPayload)
            } else {
                setInternalValue(e.data)
            }
        }

        return (
            <ByzzerSearch
                ref={ref}
                name={name}
                className={classnames(baseClassName, className)}
                search={findBrandsForOmni}
                onChange={handleChange}
                value={internalValue}
                label={label as any}
                placeholder={placeholder}
                maxSelections={maxBrands}
                disabled={disabled}
            />
        );
    }
);
export default OmniBrandSearch;

OmniBrandSearch.displayName = 'OmniBrandSearch';